interface V3IconMutedProps extends React.SVGProps<SVGSVGElement> {
    stroke?: string;
}

export const V3IconMuted = ({ stroke = "#6E7687", ...rest }: V3IconMutedProps) => <svg width="24" height="24" {...rest} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6 15H4a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h2l3.5-4.5A.8.8 0 0 1 11 5v14a.8.8 0 0 1-1.5.5L6 15ZM20 10l-4 4m0-4 4 4-4-4Z" stroke={stroke} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
</svg>